import { RequestStatus } from 'shared/constants/State';
import { IStoreState } from 'state/rootReducer';

export const isOptinConfirmationModalOpen = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.isOptinConfirmationModalOpen;

export const isFetchingPharmas = ({ freeSamples }: IStoreState): boolean =>
  freeSamples.optInConfirmation.availablePharmas?.status ===
  RequestStatus.Pending;

export const getPharmas = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.availablePharmas?.pharmas ?? [];

export const getSelectedPharmas = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.selectedPharmas ?? [];

export const isFetchingCategories = ({ freeSamples }: IStoreState): boolean =>
  freeSamples.optInConfirmation.availableCategories?.status ===
  RequestStatus.Pending;

export const getCategories = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.availableCategories?.categories ?? [];

export const getSelectedCategories = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.selectedCategories ?? [];

export const isPharmasOffCanvasOpen = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.isPharmasOffCanvasOpen;

export const isSuccessModalOpen = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.isSuccessModalOpen;

export const isOptInAccepted = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.status === RequestStatus.Success;

export const isAddressModalOpen = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.isAddressModalOpen;

export const isCategoriesOffCanvasOpen = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.isCategoriesOffCanvasOpen;

export const getOptInPersonalData = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.optInPersonalData;

export const getOptInAddressData = ({ freeSamples }: IStoreState) =>
  freeSamples.optInConfirmation.optInAddressData;

export const getClinicId = ({ userInfo }: IStoreState) => userInfo.clinicId;
